import { createContext, useContext } from "react";

import type { CardPadding, CardVariant } from "./styles";

interface CardContextValue {
  variant: CardVariant;
  padding: CardPadding;
  divided: boolean;
}

// Context rather than a `group-data-*` selector: a group selector matches any ancestor, so a
// default card nested in a floating one would pick up the outer card's spacing.
export const CardContext = createContext<CardContextValue>({ variant: "default", padding: "parts", divided: false });

export const useCardContext = () => useContext(CardContext);
